import { useQuery } from 'react-query';
import { getMoneyPoolManagementByWebKey } from 'services/fund';
import { useEffect } from 'react'
import { toast } from 'react-toastify'

export default function useGetMoneyPoolManagementByWebKey(web_key: string | undefined) {
    const { data, isLoading, error, isError } = useQuery(
        ['moneyPool-management-webKey', web_key],
        getMoneyPoolManagementByWebKey,
        {
            enabled: !!web_key,
        }
    );

    useEffect(() => {
        if (isError) {
            toast.error("موردی یافت نشد.");
        }
    }, [isError]);

    return {
        moneyPoolManagement: data,
        isLoadingMoneypoolManagement: isLoading,
        error,
        isError,
    };
}